import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";
import { getAnalytics, logEvent } from "firebase/analytics";
import "./Slideshow.css";
import { useRef } from "react";

const handleDragStart = (e) => e.preventDefault();

const Gallery = ({ imageUrls, ids, isActives }) => {
  const [isDragging, setIsDragging] = useState(false);
  const [clickStartTime, setClickStartTime] = useState(0); // Track when a click starts
  const analytics = getAnalytics();
  const navigate = useNavigate();
  const carouselRef = useRef();

  const MIN_HOLD_TIME = 15000; // Threshold for detecting a hold (in ms)

  const handleMouseDown = () => {
    setClickStartTime(Date.now());
    setIsDragging(false);
  };

  const handleMouseUp = (index) => {
    const clickDuration = Date.now() - clickStartTime;
    if (clickDuration < MIN_HOLD_TIME && !isDragging) {
      // If the click was short and no dragging occurred
      if (isActives[index]) {
        navigate(`/event/${ids[index]}`);
        logEvent(analytics, "Enter_event_Screen");
      }
    }
    setIsDragging(false); // Reset dragging state
  };

  const handleTouchStart = () => {
    setClickStartTime(Date.now());
    setIsDragging(false);
  };

  const handleTouchEnd = (index) => {
    const clickDuration = Date.now() - clickStartTime;
    if (clickDuration < MIN_HOLD_TIME && !isDragging) {
      // If the tap was short and no dragging occurred
      if (isActives[index]) {
        navigate(`/event/${ids[index]}`);
        logEvent(analytics, "Enter_event_Screen");
      }
    }
    setIsDragging(false); // Reset dragging state
  };

  const handleMouseMove = () => setIsDragging(true);
  const handleTouchMove = () => setIsDragging(true);

  // Group image URLs into individual slides
  const items = imageUrls.map((url, index) => (
    <div
      key={index}
      style={{
        display: "flex",
        justifyContent: "center",
        margin: "0 16px", // Spacing between images
      }}
    >
      <img
        src={url}
        alt={`Image ${index + 1}`}
        onDragStart={handleDragStart}
        role="presentation"
        onMouseDown={handleMouseDown}
        onMouseUp={() => handleMouseUp(index)}
        onTouchStart={handleTouchStart}
        onTouchEnd={() => handleTouchEnd(index)}
        onMouseMove={handleMouseMove}
        onTouchMove={handleTouchMove}
        style={{
          width: "621px",
          height: "500px",
          cursor: "pointer",
        }}
      />
    </div>
  ));

  return (
    <div
      className="slideshow-container"
      style={{
        position: "relative",
        width: "100%",
        height: "600px",
        margin: 0,
        padding: 0,
        overflow: "hidden",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <button
        className="slideshow-arrow"
        style={{
          position: "absolute",
          left: 24,
          top: "50%",
          transform: "translateY(-50%)",
          background: "rgba(0,0,0,0.3)",
          border: "none",
          padding: 0,
          cursor: "pointer",
          zIndex: 2,
          borderRadius: "50%",
          width: 60,
          height: 60,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        onClick={() => carouselRef.current?.slidePrev()}
        tabIndex={-1}
        aria-label="Previous slide"
      >
        {/* Left chevron SVG */}
        <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6" /></svg>
      </button>
      <button
        className="slideshow-arrow"
        style={{
          position: "absolute",
          right: 24,
          top: "50%",
          transform: "translateY(-50%)",
          background: "rgba(0,0,0,0.3)",
          border: "none",
          padding: 0,
          cursor: "pointer",
          zIndex: 2,
          borderRadius: "50%",
          width: 60,
          height: 60,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        onClick={() => carouselRef.current?.slideNext()}
        tabIndex={-1}
        aria-label="Next slide"
      >
        {/* Right chevron SVG */}
        <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 6 15 12 9 18" /></svg>
      </button>
      <AliceCarousel
        ref={carouselRef}
        mouseTracking
        items={items}
        infinite={false}
        disableButtonsControls
        responsive={{
          0: { items: 1.5 },
          768: { items: 2.5 },
          1200: { items: 2.5 },
        }}
        controlsStrategy="responsive"
        autoWidth={false}
        renderDotsItem={() => null}
        style={{ width: "100%" }}
      />
    </div>
  );
};

export default Gallery;
